export enum AuthType{
    EMAIL_ADDRESS = 'email_address',
    GOOGLE_AUTH = 'google_auth',
    FACEBOOK_AUTH = 'facebook_auth'
}